import { Injectable } from '@angular/core';
import { Observable, of, switchMap, map } from 'rxjs';
import { AdminQueriesService } from '../api/adminQueries.service';
import { SafelyPortalAPIService } from '../api/safelyPortalAPI.service';
import { Pageable } from '../models/pageable';
import { Referral } from '../models/referral';
import { ReferralRepository } from './referral-repository';
import { ReferralDTO } from '../models/referralDTO';


@Injectable({
  providedIn: 'root'
})
export class ReferralRepositoryService implements ReferralRepository {

  constructor(
    private _commandService: SafelyPortalAPIService,
    private _queryService: AdminQueriesService
  ) { }

  save(referral: Referral): Observable<Referral> {
    return this._commandService.createReferral(referral.toCreateReferralCommand())
      .pipe(
        switchMap(x => {
          let ref = Referral.fromDTO(x);
          if (ref) {
            return of(ref);
          } else {
            throw Error("Referral could not be saved.")
          }
        }
        ));
  }

  update(referral: Referral): Observable<Referral> {
    return this._commandService.updateReferral(referral.toUpdateReferralCommand())
      .pipe(
        switchMap(x => {
          let ref = Referral.fromDTO(x);
          if (ref !== undefined) {
            return of(ref);
          } else {
            throw Error("Referral could not be updated.")
          }
        }
        ));
  }

  findById(id: string): Observable<Referral> {
    return this._queryService.getById1(id)
      .pipe(
        switchMap(x => {
          let ref = Referral.fromDTO(x);
          if (ref !== undefined) {
            return of(ref);
          }
          throw Error("Could not get referral with id " + id);
        }
        ));
  }

  deleteById(id: string): Observable<boolean> {
    return this._commandService.deleteReferral(id)
      .pipe(
        switchMap(x => {
          return of(true);
        }
        ));
  }

  findAll(pageable: Pageable, search: string): Observable<Referral[]> {
    return this._queryService.getAllReferrals(pageable, search)
      .pipe(
        switchMap(x => of(x.content)),
        switchMap(x => {
          let referralList: Referral[] = [];
          if (x) {
            x.forEach((item: ReferralDTO) => {
              var referral = Referral.fromDTO(item);
              if (referral) {
                referralList.push(referral);
              }
            })
            return of(referralList)
          }
          return of([])
        })
      )
  }
}